import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})

/** breadcrumb component*/
export class BreadcrumbComponent {
  @Input() paths: Array<string>;
  links: object[];
  @Input() displayTrail = true;

  constructor() {
    
  }

  ngOnInit() {
    this.links = new Array<object>();
    try {
      if (this.paths !== null && this.paths !== undefined && this.paths.length > 0) {

        for (let i = 0; i < this.paths.length; i += 2) {
          this.links.push({ 'title': this.paths[i], 'url': this.paths[i + 1] });
        }
        //console.log(this.links);
      }

    } catch (e) {
      console.error(e.message);
    }
    //console.log("Show: " + ((this.displayTrail === true) ? "yes" : "No"));
  }
}
